import { isRouteErrorResponse } from 'react-router-dom';

export class PageNotFoundError extends Error {
  constructor() {
    super('Page not found');
    this.name = 'PageNotFoundError';
  }
}

/**
 * Extracts a human-readable error message from an unknown error value.
 * Handles React Router ErrorResponse objects, Error instances, strings, and unknown types.
 */
export function getErrorMessage(error: unknown): string {
  if (isRouteErrorResponse(error)) {
    const data =
      error.data != null ? (typeof error.data === 'string' ? error.data : JSON.stringify(error.data, null, 2)) : '';
    return `${String(error.status)} ${error.statusText}${data !== '' ? `\n${data}` : ''}`;
  }

  if (error instanceof Error) {
    return error.stack ?? error.message;
  }

  if (typeof error === 'string') {
    return error;
  }

  return String(error);
}
